namespace Gamification.Gamification {
    export namespace ProdottiParametriGlobaliService {
        export const baseUrl = 'Gamification/ProdottiParametriGlobali';

        export declare function Create(request: Serenity.SaveRequest<ProdottiParametriGlobaliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiParametriGlobaliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiParametriGlobaliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiParametriGlobaliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiParametriGlobali/Create",
            Update = "Gamification/ProdottiParametriGlobali/Update",
            Delete = "Gamification/ProdottiParametriGlobali/Delete",
            Retrieve = "Gamification/ProdottiParametriGlobali/Retrieve",
            List = "Gamification/ProdottiParametriGlobali/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiParametriGlobaliService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
